import { useMemo } from 'react';

import { convertTimeLetter, formatTimeEvent } from '@helpers';
import type { DashboardResult } from '@api/domain/types';

import { getDashboardResultName } from '@v2/pages/dashboard/common/helpers';

export interface UseManageDashboardListActualRowParams {
  item: DashboardResult;
}

export const useManageDashboardListActualRow = ({ item }: UseManageDashboardListActualRowParams) => {
  const seconds = item.totalTimeTotalInSeconds ?? 0;

  const valueText = useMemo(
    () => formatTimeEvent(convertTimeLetter(Math.abs(seconds)), false, false).trim(),
    [seconds]
  );

  const name = useMemo(() => getDashboardResultName(item), [item]);

  return { seconds, valueText, name };
};
